import { ShoppingCartsContext } from 'context/ShoppingCartsContext';
import { useEffect } from 'react';
import { useState } from 'react';
import { ReactNode } from 'react';

import AddToCartModal from 'components/desktop/ShoppingCart/_general/AddToCartModal/Index';
import * as ShoppingCartContext from 'types/ShoppingCart/ShoppingCartContext';

type Props = {
	children: ReactNode;
};
export function ShoppingCartsContextProvider({ children }: Props) {
	const [context, setContext] = useState<ShoppingCartContext.Type>(ShoppingCartContext.create());

	useEffect(() => {
		initialize();
	}, []);

	const initialize = async () => {
		setContext(await ShoppingCartContext.initialize());
	};

	const initializeWithoutDetails = async () => {
		setContext(await ShoppingCartContext.initializeWithoutDetails(context));
	};

	return (
		<ShoppingCartsContext.Provider
			value={{
				value: context,
				setValue: setContext,
				initializeWithoutDetails: initializeWithoutDetails,
			}}
		>
			<AddToCartModal />
			{children}
		</ShoppingCartsContext.Provider>
	);
}
